import { formatPercentWithCount } from '../../../../utility';

export const YOE_OPTIONS = {
    chart: {
        id: 'chart1',
        toolbar: { show: false }
    },
    colors: ['#AD509E'],
    noData: {
        text: 'No data to show.',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined
        }
    },
    legend: { 
        show: true,
        position: 'top',
        horizontalAlign: 'right',
        showForSingleSeries: true, 
        markers: {
            width: 8,
            height: 8,
            radius: 8
        }
    },
    xaxis: {
        title: {
            text: 'Years of Experience',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        labels: {
            style: {
                colors: Array.from({ length: 20 })?.map(()=> '#667085'),
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label'
            }
        },
        crosshairs: { show: false }
    },
    yaxis: {
        title: {
            text: 'Total HCPs',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title'
            }
        },
        labels: {
            style: {
                colors: ['#667085'],
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label'
            }
        }
    },
    tooltip: {
        custom: function({
            series, seriesIndex, dataPointIndex, w 
        }) {
            const value = series[seriesIndex][dataPointIndex];

            return `<div class="distribution-by-yop-custom-tool-tip arrow_box"> 
                    <p class="tool-tip-series-name">${value}</p>                
                </div>`;
        }        
    },
    grid: { show: false },
    plotOptions: {
        bar: {
            columnWidth: '50%',
            borderRadius: 2
        }
    },
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
    },
    dataLabels: { enabled: false }
};
export const YOE_SERIES = [
    {
        name: 'No. of Doctors',
        data: [
            { x: 'less than 5 years', y: 300 },
            { x: '5 - 10 years', y: 800 },
            { x: '10 - 15 years', y: 812 },
            { x: '15 - 20 years', y: 600 },
            { x: '20+ years', y: 250 }
        ]
    }
];

export const SPECIALITY_OPTIONS = {
    chart: {
        id: 'chart1',
        toolbar: { show: false },
        height: 900
    },
    colors: ['#AD509E'],
    noData: {
        text: 'No data to show.',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined
        }
    },
    legend: { 
        show: true,
        position: 'top',
        horizontalAlign: 'right',
        showForSingleSeries: true, 
        markers: {
            width: 8,
            height: 8,
            radius: 8
        }
    },
    xaxis: {
        title: {
            text: 'Specialties',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        labels: {
            rotate: -45,
            rotateAlways: true,
            formatter: function (val) {
                if (val === null || val === undefined) return '';
                const str = String(val);
                return str.length > 30 ? str.substring(0, 20) + '...' : str;
            },
            style: {
                colors: [], // let Apex auto-assign, avoids mismatch
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label'
            }
        },
        tickPlacement: 'on',
        crosshairs: { show: false }
    },
    yaxis: {
        title: {
            text: 'Total HCPs',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title'
            }
        },
        labels: {
            style: {
                colors: ['#667085'],
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label'
            }
        }
    },
    tooltip: {
        custom: function ({
            series, seriesIndex, dataPointIndex 
        }) {
            const value = series[seriesIndex][dataPointIndex];
            return `<div class="distribution-by-yop-custom-tool-tip arrow_box"> 
                    <p class="tool-tip-series-name">${value}</p>                
                  </div>`;
        }
    },      
    grid: { show: false },
    plotOptions: {
        bar: {
            columnWidth: '80%',
            borderRadius: 2
        }
    },
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
    },
    dataLabels: { enabled: false }
};

export const SPECIALITY_SERIES = [
    {
        name: 'No. of Doctors',
        data: [
            { x: 'Oncology', y: 1900 },
            { x: 'Internal Medicine', y: 1800 },
            { x: 'Hematology', y: 1700 },
            { x: 'Surgery', y: 1600 },
            { x: 'Otolaryngology', y: 1500 },
            { x: 'Cardiology', y: 1400 },
            { x: 'Pediatrics', y: 1300 },
            { x: 'Surgical Oncology', y: 1250 },
            { x: 'Dermatology', y: 1000 },
            { x: 'Psychiatry & Neurology', y: 750 },
            { x: 'Hospitals', y: 500 },
            { x: 'Neurological Surgery', y: 250 }
        ]
    }
];

export const LOCATION_CHART_OPTIONS = {
    title: { text: null },
    chart: {
        backgroundColor: 'transparent',
        type: 'map',
        map: null
    },
    mapNavigation: {
        enabled: false,
        enableButtons: false
    },
    navigation: { buttonOptions: { enabled: false } },
    credits: { enabled: false },
    colorAxis: {
        min: 1,
        type: 'logarithmic',
        minColor: '#FAEDF9',
        maxColor: '#8C3F7D',
        stops: [
            [0, '#FAEDF9'],
            [0.67, '#DB97D2'],
            [1, '#8C3F7D']
        ]
    },
    tooltip: {
        formatter: function () {
            return (
                '<b>' + this.point.name + '</b><br/>' + this.point.value
            );
        }
    },
    legend: {
        enabled: true,
        align: 'right',
        horizontalAlign: 'bottom',
        layout: 'horizontal',
        borderWidth: 0,
        margin: 0,
        x: -50,
        y: 0
    },
    series: [
        {
            name: 'us map',
            dataLabels: {
                enabled: true,
                color: '#FFFFFF',
                format: '{point.postal-code}',
                // align: 'center',
                shadow: false,
                backgroundColor: 'transparent',
                zIndex: 6,
                style: {
                    textTransform: 'uppercase',
                    fontWeight: 'normal', 
                    fontStyle: 'normal', 
                    textOutline: 'none' 
                }
            },
            cursor: 'pointer',
            joinBy: 'postal-code'
        }
    ]
};

export const PRACTICE_LOCATION_CHART_OPTIONS = {
    chart: {
        type: 'bar',
        backgroundColor: '#F9FAFB'
    },
    colors: ['#AD509E'],
    title: { text: null },
    subtitle: { text: null },
    navigation: { buttonOptions: { enabled: false } },
    xAxis: {
        type: 'category',
        title: { text: null },
        lineColor: 'transparent'
    },
    yAxis: {
        labels: { enabled: false },
        title: { text: null },
        gridLineWidth: 0
    },
    plotOptions: {
        bar: {
            dataLabels: {
                enabled: true,
                x: 1
            }
        },
        series: {
            label: { enabled: false },
            states: { hover: { enabled: false } },
            borderRadius: 5,
            pointWidth: 8,
            groupPadding: 1,
            pointPadding: 1
        }
    },
    legend: { enabled: false },
    tooltip: { enabled: false },
    credits: { enabled: false },
    series: [
        {
            name: null,
            data: [
                ['VA 21.9%', 99600],
                ['IN 14.6%', 68400],
                ['WA 13.1%', 59578],
                ['AL 11.7%', 53210],
                ['RI 11.6%', 52756],
                ['ME 7.4%', 33654],
                ['OR 6.2%', 28197],
                ['CA 5.7%', 25923],
                ['AK 5.2%', 23649],
                ['GA 4.2%', 19101],
                ['NV 2.2%', 10005],
                ['FL 1.4%', 6367],
                ['PA 0.3%', 1364]
            ]
        }
    ]
};

/* Affinity By Segment */ 
export const AFFINITY_SEGMENT = [
    'Digital Affinity',
    'Personal Promotion Affinity',
    'Peer To Peer Affinity'
];

export const AFFINITY_CHART_OPTIONS = {
    chart: {
        type: 'bar',
        toolbar: { show: false },
        stacked: true
    },

    noData: {
        text: 'No data to show',
        align: 'center',
        verticalAlign: 'middle',
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#303030'
        }
       
    },

    colors: ['#E9BEE3','#DB97D2', '#C76EBA', '#AD509E', '#733567'],
    plotOptions: {
        bar: {
            horizontal: false,
            borderRadius: 4,
            dataLabels: { position: 'top' }
        }
    },
    dataLabels: {
        enabled: true,
        textAnchor: 'middle',
        style: {
            colors: ['#FFFFFF'],
            fontSize: '12px',
            fontWeight: '500'                    
        },
        formatter: function (val, opt) {
            const formattedVal = val?.toString() + '%';
            return formattedVal;
        }
    },
    legend: {
        position: 'top',
        horizontalAlign: 'center',
        markers: { radius: 12 }
    },
    grid: { show: true },
    xaxis: {
        title: {
            text: 'Segments',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        categories: [],
        labels: {
            formatter: function (val) {
                return val.length > 30 ? val.substring(0, 30) + '...' : val;
            },
            style: {
                fontSize: '12px',
                fontWeight: 400,
                fontFamily: 'Inter',
                cssClass: 'apexcharts-xaxis-label-custom-color'
            }
        }   
    },
    yaxis: {
        title: {
            text: '% HCPs',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title'
            }
        },
        labels: {
            formatter: function (val) {
                return val + '%';
            },
            style: {
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label'
            }
        },
        tickAmount: 5,
        max: 100
    },
    tooltip: {
        custom: function({
            series, seriesIndex, dataPointIndex, w 
        }) {
            const dataPointName = w.globals.labels[dataPointIndex];
            const seriesName = w.globals.seriesNames[seriesIndex];
            const value = series[seriesIndex][dataPointIndex];
            const count = w.config.series[seriesIndex]?.counts?.[dataPointIndex];

            return `<div class="custom-tool-tip-container arrow_box tool_tip_fullName"> 
                    <p class="tool-tip-label-name margin-0 fw_bold">${dataPointName}</p>
                    <p class="tool-tip-series-name margin-0">${seriesName}: ${formatPercentWithCount(value, count)}</p>                
                </div>`;
        }        
    }
};

export const AFFINITY_CHART_SERIES = [
    {
        name: 'Low',
        data: [0, 12.1, 31.4, 15.2, 11.6, 9.6, 15.2, 15.2]
    },
    {
        name: 'Medium',
        data: [48.7, 37.5, 12.1, 49.2, 26.9, 46.7, 13.1, 23.3]
    },
    {
        name: 'High',
        data: [19.2, 20.8, 38.5, 26.3, 36.5, 27, 52.7, 38.2]
    },
    {
        name: 'Very High',
        data: [16.7, 29.4, 17.7, 9.1, 24.8, 16.7, 18.7, 23.3]
    }
];

/* Personal Promotion Channel Affinity */
export const PERSONAL_PROMOTION_CHANNEL_CHART_OPTIONS = {
    chart: {
        type: 'bar',
        toolbar: { show: false },
        stacked: true
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    colors: ['#E9BEE3','#DB97D2','#C76EBA', '#AD509E', '#733567'],
    plotOptions: {
        bar: {
            horizontal: false,
            borderRadius: 4,
            dataLabels: { position: 'top' }
        }
    },
    dataLabels: {
        enabled: true,
        textAnchor: 'middle',
        style: {
            colors: ['#FFFFFF'],
            fontSize: '12px',
            fontWeight: '500'                    
        },
        formatter: function (val, opt) {
            const formattedVal = val.toString() + '%';
            return formattedVal;
        }
    },
    legend: {
        position: 'top',
        horizontalAlign: 'center',
        markers: { radius: 12 }
    },
    grid: { show: true },
    xaxis: {
        title: {
            text: 'Channels',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        categories: [
            'Rep Triggered Digital',
            'Personal - F2F',
            'Phone Call',
            'Virtual Presentation'
        ],
        labels: {
            formatter: function (val) {
                return val.length > 30 ? val.substring(0, 30) + '...' : val;
            },
            style: {
                fontSize: '12px',
                fontWeight: 400,
                fontFamily: 'Inter',
                cssClass: 'apexcharts-xaxis-label-custom-color'
            }
        }  
    },
    yaxis: {
        title: {
            text: '% HCPs',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title'
            }
        },
        labels: {
            formatter: function (val) {
                return val + '%';
            },
            style: {
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label'
            }
        },
        tickAmount: 5,
        max: 100
    },
    tooltip: {
        custom: function({
            series, seriesIndex, dataPointIndex, w 
        }) {
            const dataPointName = w.globals.labels[dataPointIndex];
            const seriesName = w.globals.seriesNames[seriesIndex];
            const value = series[seriesIndex][dataPointIndex];
            const count = w.config.series[seriesIndex]?.counts?.[dataPointIndex];

            return `<div class="custom-tool-tip-container arrow_box tool_tip_fullName"> 
                    <p class="tool-tip-label-name margin-0 fw_bold">${dataPointName}</p>
                    <p class="tool-tip-series-name margin-0">${seriesName}: ${formatPercentWithCount(value, count)}</p>                
                </div>`;
        }        
    }
};

export const PERSONAL_PROMOTION_CHANNEL_CHART_SERIES = [
    {
        name: 'Low',
        data: [15.2, 12.1, 31.4, 15.2]
    },
    {
        name: 'Medium',
        data: [48.7, 37.5, 12.1, 49.2]
    },
    {
        name: 'High',
        data: [19.2, 20.8, 38.5, 26.3]
    },
    {
        name: 'Very High',
        data: [16.7, 29.4, 17.7, 9.1]
    }
];

export const PREFERENCES = [
    'All',
    '1st Preference',
    '2nd Preference',
    '3rd Preference'
];

/* Channels */
export const VIRTUAL_CHART_OPTIONS = {
    chart: { type: 'donut' },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    stroke: { show: false },
    states: {
        hover: {
            filter: {
                type: 'darken',
                value: 0.50
            }
        }
    },

    colors: ['#E0F2FE','#7CD4FD', '#36BFFA', '#0BA5EC'],
    labels: ['Low', 'Medium', 'High', 'Very High'],
    legend: {
        show: false,
        position: 'bottom'
    },
    dataLabels: { enabled: false },
    tooltip: {
        custom: function({
            series, seriesIndex, dataPointIndex, w 
        }) {
            const seriesName = w.globals.seriesNames[seriesIndex];
            const value = series[seriesIndex];
            const count = w.config.counts?.[seriesIndex];

            return `<div class="peer-to-peer-custom-tool-tip" style="width:auto;min-width:150px;height:auto;padding:8px 12px;white-space:nowrap;box-sizing:border-box;"> 
                    <p class="tool-tip-series-name">${seriesName}: ${formatPercentWithCount(value, count)}</p>                
                </div>`;
        }        
    }
    // responsive: [{
    //     breakpoint: 1400,
    //     options: { legend: { fontSize: '10px' } }
    // }]
};

export const VIRTUAL_CHART_SERIES = [44, 55, 13, 33];

export const IN_PERSON_CHART_OPTIONS = {
    chart: { type: 'donut' },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    stroke: { show: false },
    states: {
        hover: {
            filter: {
                type: 'darken',
                value: 0.50
            }
        }
    },
    colors: ['#E9BEE3','#DB97D2', '#C76EBA', '#AD509E', '#733567'],
    labels: ['Low', 'Medium', 'High', 'Very High'],
    legend: {
        show: false,
        position: 'bottom'
    },
    dataLabels: { enabled: false },
    tooltip: {
        custom: function({
            series, seriesIndex, dataPointIndex, w 
        }) {
            const seriesName = w.globals.seriesNames[seriesIndex];
            const value = series[seriesIndex];
            const count = w.config.counts?.[seriesIndex];

            return `<div class="peer-to-peer-custom-tool-tip " style="width:auto;min-width:150px;height:auto;padding:8px 12px;white-space:nowrap;box-sizing:border-box;"> 
                    <p class="tool-tip-series-name">${seriesName}: ${formatPercentWithCount(value, count)}</p>                
                </div>`;
        }        
    }
    // responsive: [{
    //     breakpoint: 1400,
    //     options: { legend: { fontSize: '10px' } }
    // }]
};

export const IN_PERSON_CHART_SERIES = [44, 55, 13, 33];

export const SEMI_DONUT_CHART_SERIES = [58.2, 41.8];

export const SEMI_DONUT_CHART_OPTIONS = {
    chart: { type: 'donut' },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    colors: ['#36BFFA', '#C76EBA'],
    labels: ['Virtual', 'In-Person'],
    legend: {
        show: false,
        position: 'bottom'
    },
    stroke: { show: false },
    dataLabels: { enabled: false },
    plotOptions: {
        pie: {
            startAngle: -90,
            endAngle: 90,
            offsetY: 10
        }
    },
    grid: { padding: { bottom: -150 } },
    tooltip: {
        custom: function({
            series, seriesIndex, dataPointIndex, w 
        }) {
            const seriesName = w.globals.seriesNames[seriesIndex];
            const value = series[seriesIndex];
            const count = w.config.counts?.[seriesIndex];

            return `<div class="peer-to-peer-custom-tool-tip" style="width:auto;min-width:150px;height:auto;padding:8px 12px;white-space:nowrap;box-sizing:border-box;"> 
                    <p class="tool-tip-series-name">${seriesName}: ${formatPercentWithCount(value, count)}</p>                
                </div>`;
        }        
    }
    // responsive: [{
    //     breakpoint: 1400,
    //     options: {
    //         grid: { padding: { bottom: -100 } },
    //         legend: { fontSize: '10px' }
    //     }
    // }]
};

/* Vendor Affinity Channels  */
export const VENDOR_AFFINITY_CHANNELS = [
    'E-mail',
    'Banner',
    'Programmatic',
    'Custom Media',
    'EHR',
    'Endemic Social',
    'Direct mail'
];

/* Content Affinity */ 
const KEYWORD_CHART_SERIES = [
    {
        name: 'Management',
        value: 12.56,
        colorValue: 12
    },
    {
        name: 'Case manager',
        value: 6.75,
        colorValue: 6
    },
    {
        name: 'Nociceptive Pain',
        value: 16.43,
        colorValue: 16
    },
    {
        name: 'Crap Gap',
        value: 9.07,
        colorValue: 9
    },
    {
        name: 'Regimen',
        value: 5.67,
        colorValue: 5
    },
    {
        name: 'Radiologically Isolated Syndrome (RIS)',
        value: 11.03,
        colorValue: 11
    },
    {
        name: 'Clinically Isolated Syndrome (CIS)',
        value: 24.12,
        colorValue: 24
    },
    {
        name: 'Neoadjuvant therapy',
        value: 12.41,
        colorValue: 12
    },
    {
        name: 'Imaging test',
        value: 6.0,
        colorValue: 6
    },
    {
        name: 'Targeted therapy',
        value: 3.66,
        colorValue: 3
    },
    {
        name: 'Oligoclonal Bands',
        value: 2.04,
        colorValue: 2
    }
];

export const CHART_OPTIONS_KEYWORD_3 = {
    chart: {
        type: 'treemap',
        height: '396px',
        plotBackgroundColor: null,
        backgroundColor: 'transparent',
        margin: 0
    },
    title: { text: null },
    navigation: { buttonOptions: { enabled: false } },
    credits: { enabled: false },
    legend: { enabled: false },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
            fontSize: '10px',
            fontWeight: 400
        },
        formatter: function() {
            const value = this.series.valueData[this.x];
            return `<b>${this.key}</b>: ${formatPercentWithCount(value, this.point?.hcpCount)}<br>`;
        }
    },
    colorAxis: {
        minColor: '#D1E8FC',
        // #9cd1fc
        maxColor: '#53B1FD'
    },
    plotOptions: {
        treemap: {
            layoutAlgorithm: 'sliceAndDice',
            alternateStartingDirection: true,
            borderColor: '#fff',
            borderRadius: 6,
            borderWidth: 2,
            dataLabels: {
                style: {
                    textOutline: 'none',
                    fontSize: '12px',
                    fontWeight: 400
                }
            }
        }
    },
    series: [
        {   
            name: 'Keyword 3',
            data: KEYWORD_CHART_SERIES
        }
    ],
    responsive: {
        rules: [{
            condition: { maxWidth: 250 // Work Before Width 1249px for column 4 if maxWidth is 250.
            },
            chartOptions: { tooltip: { style: { fontSize: '10px' } } }
        }]
    }
};

/* Topic and Content Types */
export const CONTENT_TYPE_CHART_OPTIONS = {
    colors: ['#8C3F7D', '#DB97D2'],
    lang: { noData: 'No data to display' },
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#303030'
        }
    },
    chart: {
        type: 'pie',
        backgroundColor: null,
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: 150,
        
        spacingTop: 0,
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0
    },
    // accessibility: {
    //     point: {
    //         valueSuffix: '%'
    //     }
    // },'#36BFFA'
    title: { text: null },
    subtitle: { text: null },
    exporting: { enabled: false },
    credits: { enabled: false },
    // tooltip: {
    //     pointFormat: '{series.name}: <b>{point.percentage:.0f}%</b>'
    // },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
            fontSize: '10px'
        },
        formatter: function() {
            return `<b>${this.key}</b>: ${formatPercentWithCount(this.y, this.point?.count)} <br>`;
        }
    },
    legend: {
        margin: 4,
        align: 'right',
        layout: 'vertical',
        verticalAlign: 'top',
        x: 0,
        y: 10,
        itemStyle: {
            color: '#667085',
            fontWeight: 400,
            fontSize: '12px'
        }
    },
    plotOptions: {
        pie: {
            shadow: false,
            borderWidth: 0,
            allowPointSelect: false,
            size: '100%',
            dataLabels: { enabled: false }
        }
    },
    series: [
        {
            name: 'Content Type',
            data: [
                {
                    name: 'Branded',
                    y: 58.2
                },
                {
                    name: 'Unbranded',
                    y: 41.8
                }
            ],
            size: '60%',
            innerSize: '70%',
            showInLegend: true,
            // enableMouseTracking: false,
            borderRadius: 0
            // dataLabels: {
            // enabled: false,
            // crop: false,
            // distance: '-10%',
            // style: {
            //     fontWeight: 'bold',
            //     fontSize: '16px'
            // },
            // connectorWidth: 0
            // },
        }
    ]
};

export const TOPIC_CHART_OPTIONS = {
    colors: ['#FCCEEE', '#E9BEE3', '#DB97D2', '#C76EBA', '#F3DBF1','#AD509E', '#8C3F7D', '#733567','#FCE7F6', '#602F56', '#3D1535'],
    lang: { noData: 'No data to display' },
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#303030'
        }
    },
    chart: {
        type: 'pie',
        backgroundColor: null,
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: 150,
        
        spacingTop: 0,
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0
    },
    // accessibility: {
    //     point: {
    //         valueSuffix: '%'
    //     }
    // },
    title: { text: null },
    subtitle: { text: null },
    exporting: { enabled: false },
    credits: { enabled: false },
    // tooltip: {
    //     pointFormat: '{series.name}: <b>{point.percentage:.0f}%</b>'
    // },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        outside: true,
        style: {
            color: '#fff',
            fontSize: '10px',
            whiteSpace: 'nowrap'
        },
        formatter: function() {
            return `<b>${this.key}</b>: ${formatPercentWithCount(this.y, this.point?.count)} <br>`;
        }
    },
    legend: {
        margin: 4,
        align: 'right',
        layout: 'vertical',
        verticalAlign: 'top',
        x: 0,
        y: 10,
        itemStyle: {
            color: '#667085',
            fontWeight: 400,
            fontSize: '12px'
        }
    },
    plotOptions: {
        pie: {
            shadow: false,
            borderWidth: 0,
            allowPointSelect: false,
            size: '100%',
            dataLabels: { enabled: false }
        }
    },
    series: [
        {
            name: 'Topic',
            data: [
                {
                    name: 'Efficacy',
                    y: 20
                },
                {
                    name: 'Safety',
                    y: 20
                },
                {
                    name: 'Dosing',
                    y: 35
                },
                {
                    name: 'MOA',
                    y: 13
                },
                {
                    name: 'Disease state',
                    y: 12
                }
            ],
            size: '60%',
            innerSize: '70%',
            showInLegend: true,
            // enableMouseTracking: false,
            borderRadius: 0
            // dataLabels: {
            // enabled: false,
            // crop: false,
            // distance: '-10%',
            // style: {
            //     fontWeight: 'bold',
            //     fontSize: '16px'
            // },
            // connectorWidth: 0
            // },
        }
    ]
};

/* Distribution by years of experience */ 
export const CHART_OPTIONS = {
    chart: {
        id: 'distribution-by-yoe',
        toolbar: { show: false }
    },
    colors: ['#AD509E'],
    noData: {
        text: 'No data to show.',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: undefined,
            fontSize: '14px',
            fontFamily: undefined
        }
    },
    legend: { show: false },
    xaxis: {
        title: {
            text: 'Years of Experience',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        labels: {
            style: {
                colors: Array.from({ length: 20 })?.map(()=> '#667085'),
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-xaxis-label'
            }
        },
        crosshairs: { show: false }
    },
    yaxis: {
        title: {
            text: 'Total HCPs',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title'
            }
        },
        labels: {
            style: {
                colors: ['#667085'],
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label'
            }
        }
    },
    tooltip: {
        custom: function({
            series, seriesIndex, dataPointIndex, w 
        }) {
            const value = series[seriesIndex][dataPointIndex];

            return `<div class="distribution-by-yop-custom-tool-tip arrow_box"> 
                    <p class="tool-tip-series-name">${value}</p>                
                </div>`;
        }        
    },
    grid: { show: false },
    plotOptions: {
        bar: {
            columnWidth: '80%',
            borderRadius: 2
        }
    },
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
    },
    dataLabels: { enabled: false }
};

export const CHART_SERIES = [
    {
        name: '',
        data: [
            { x: 'less than 5 years', y: 300 },
            { x: '5 - 10 years', y: 800 },
            { x: '10 - 15 years', y: 812 },
            { x: '15 - 20 years', y: 600 },
            { x: '20+ years', y: 250 }
        ]
    }
];

/* digital vs non-digital affinity */

export const butterflyChartOptions = {
    chart: { type: 'bar' },
    title: { text: null },
    subtitle: { text: null },
    navigation: { buttonOptions: { enabled: false } },
    credits: { enabled: false },
    legend: {
        enabled: true,
        verticalAlign: 'top',
        y: 20
    },
    tooltip: {
        shared: true,
        backgroundColor: '#000',
        borderColor: 'black',
        borderRadius: 10,
        borderWidth: 0,
        style: { color: '#fff' },
        formatter: function () {
            let tooltipText = '<b>' + this.x + '</b><br/>';
            if (this.points) {
                this.points.forEach((point) => {
                    const formattedPoint = pointTooltipFormatter.call(point, point.color);
                    if (formattedPoint) {
                        tooltipText += formattedPoint + '<br/>';
                    }
                });
            }
            return tooltipText;
        }

    },
    xAxis: [
        {
            categories: [
                '1st Preference',
                '2nd Preference',
                '3rd Preference'
            ],
            reversed: true,
            labels: {
                align: 'center',
                step: 1,
                reserveSpace: false,
                x: -5
            },
            lineWidth: 0,
            tickLength: 0,
            left: '50%'
        }
       
    ],
    yAxis: [
        {
            title: {
                text: '% HCPs', 
                useHTML: true,
                align: 'middle'
            },
            labels: { format: '{value}%' },
            reversed: true,
            left: 0,
            width: '45%',
            offset: 0,
            tickAmount: 5,
            tickInterval: 20
        },
        {
            title: {
                text: '% HCPs', 
                useHTML: true,
                align: 'middle'
                // x: -125,
            },
            labels: { format: '{value}%' },
            left: '55%',
            width: '45%',
            offset: 0,
            tickAmount: 5,
            tickInterval: 20
        }
    ],

    plotOptions: {
        series: {
            stacking: 'normal',
            dataLabels: {
                enabled: true,
                style: {
                    color: '#FFF',
                    borderWidth: 0,
                    textOutline: 0,
                    textShadow: false
                },
                formatter: function () {
                    return this.y + '%';
                }
            },
            states: { hover: { enabled: false } }
        }
    },
    series: [
        {
            yAxis: 0,
            name: 'Digital',
            data: [40, 57, 64],
            color: '#AD509E'
        },
        {
            yAxis: 1,
            name: 'Peer to Peer',
            color: '#F3DBF1',
            data: [23, 29, 18],
            dataLabels: { style: { color: '#000' } }
        },
        {
            yAxis: 1,
            name: 'Personal Promotion',
            data: [33, 14, 18],
            color: '#DB97D2'
        }
    ]
};

export const DIGITAL_CHANNEL_AFFINITY_OPTIONS = {
    chart: {
        type: 'bar',
        toolbar: { show: false },
        stacked: true
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    colors: ['#F3DBF1', '#DB97D2', '#AD509E', '#733567', '#3D1535'],
    plotOptions: {
        bar: {
            horizontal: false,
            borderRadius: 4,
            dataLabels: { position: 'top' }
        }
    },
    dataLabels: {
        enabled: true,
        textAnchor: 'middle',
        style: {
            colors: ['#FFFFFF'],
            fontSize: '12px',
            fontWeight: '500'                    
        },
        formatter: function (val, opt) {
            const formattedVal = Number(val).toString() + '%';
            return formattedVal;
        }
    },
    legend: {
        position: 'top',
        horizontalAlign: 'center',
        markers: { radius: 12 }
    },
    grid: { show: true },
    xaxis: {
        title: {
            text: 'Channels',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        categories: [
            'E-mail',
            'Banners',
            'Programmatic',
            'Custom media',
            'Endemic social',
            'SMS',
            'Direct mail',
            'EHR'
        ],
        labels: {
            formatter: function (val) {
                return val.length > 30 ? val.substring(0, 30) + '...' : val;
            },
            style: {
                fontSize: '12px',
                fontWeight: 400,
                fontFamily: 'Inter',
                cssClass: 'apexcharts-xaxis-label-custom-color'
            }
        }  
    },
    yaxis: {
        title: {
            text: '% HCPs',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title'
            }
        },
        labels: {
            formatter: function (val) {
                return val + '%';
            },
            style: {
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label'
            }
        },
        tickAmount: 5,
        max: 100
    },
    tooltip: {
        custom: function({
            series, seriesIndex, dataPointIndex, w 
        }) {
            const dataPointName = w.globals.labels[dataPointIndex];
            const seriesName = w.globals.seriesNames[seriesIndex];
            const value = series[seriesIndex][dataPointIndex];
            const count = w.config.series[seriesIndex]?.counts?.[dataPointIndex];

            return `<div class="custom-tool-tip-container arrow_box tool_tip_fullName"> 
                    <p class="tool-tip-label-name margin-0 fw_bold">${dataPointName}</p>
                    <p class="tool-tip-series-name margin-0">${seriesName}: ${formatPercentWithCount(value, count)}</p>                
                </div>`;
        }        
    }
};